import React, { useEffect, useState } from 'react'
import axios from 'axios';
import config from '../config';
import { Button, Row, Col, ListGroup } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';
import PdfViewing from './PdfViewing';

const studentCreation = [
    {
        "img": '/img/magazine/studcre.jpg',
        "Title": "இராசாத்தி",   
        "Description": "மதுரை, தூய மரியன்னை மேல்நிலைப் பள்ளியின் இளமைக்கனல் எழுத்தாளர் இயக்க முன்னாள் மாணவர் படைப்பு..",
    },
]

const buildImageUrl = (item) => {
  if (!item?.img) return '';
  if (item.img.startsWith('http://') || item.img.startsWith('https://') || item.img.startsWith('/')) return item.img;
  if (item.prgID && item.reportID) {
    return `${config.s3.imageUrl}website/kanal/${item.prgID}/${item.reportID}/${item.img}`;
  }
  return item.img;
};

const getReportDate = (item) => {
  const dateValue = item.reportDate || item.updatedOn || item.createdOn || item.updatedDate || item.reportdate || item.updatedon;
  const parsed = dateValue ? new Date(dateValue) : null;
  return parsed && !Number.isNaN(parsed.valueOf()) ? parsed : new Date(0);
};

const formatMonthYear = (item) => {
  const date = getReportDate(item);
  if (!date || date.getFullYear() === 1970) return '';
  return date.toLocaleString('default', { month: 'short', year: 'numeric' });
};

export default function KanalMagazine() {
  const [magazine, setMagazine] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const yearGroups = magazine.reduce((groups, item) => {
    const year = getReportDate(item).getFullYear() || 'Unknown';
    if (!groups[year]) groups[year] = [];
    groups[year].push(item);
    return groups;
  }, {});

  const yearList = Object.keys(yearGroups).sort((a, b) => {
    if (a === 'Unknown') return 1;
    if (b === 'Unknown') return -1;
    return Number(b) - Number(a);
  });

  useEffect(() => {
    if (!selectedYear && yearList.length > 0) {
      setSelectedYear(yearList[0]);
    }
  }, [selectedYear, yearList]);

  useEffect(() => {
    const fetchMagazine = async () => {
      setLoading(true);
      setError('');

      try {
        const fetchKey = 'Kanal';
        const fetchOption = 'ReportCategory';
        const response = await axios.get(`${config.api.invokeURL}/website/reports?fetchKey=${fetchKey}&fetchOption=${fetchOption}`, {
          headers: {
            'x-api-key': config.api.key,
          },
        });

        const rawData = Array.isArray(response.data)
          ? response.data
          : Array.isArray(response.data?.data)
          ? response.data.data
          : [];

        const sorted = [...rawData].sort((a, b) => getReportDate(b) - getReportDate(a));
        const latestDate = sorted.length > 0 ? getReportDate(sorted[0]).valueOf() : null;
        const olderItems = latestDate !== null
          ? sorted.filter((item) => getReportDate(item).valueOf() !== latestDate)
          : [];

        setMagazine(olderItems);
      } catch (fetchError) {
        console.error('Failed to load Kanal magazine details:', fetchError);
        setError('Unable to load Kanal magazine details from API.');
      } finally {
        setLoading(false);
      }
    };

    fetchMagazine();
  }, []);

  const selectedItems = selectedYear ? yearGroups[selectedYear] : [];

  return (
    <div className='container'>
      {loading && <div className='text-muted mb-3'>Loading Kanal magazine details...</div>}
      {error && <div className='text-danger mb-3'>{error}</div>}
      <Row>
        <Col md={3}>
          <h4 className='mb-3'>Report Years</h4>
          <ListGroup>
            {yearList.map((year) => (
              <ListGroup.Item
                key={year}
                action
                active={selectedYear === year}
                onClick={() => setSelectedYear(year)}
              >
                {year}
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Col>

        <Col md={9}>
          <h4 className='mb-3'>{selectedYear ? `${selectedYear} Issues` : 'Magazine Details'}</h4>
          <CardGroup>
            {selectedItems.map((item, index) => (
              <Card className='m-2' key={item.reportID || index}>
                <Card.Img
                  className='img-responsive'
                  variant="top"
                  src={buildImageUrl(item)}
                  style={{height:"250px"}}
                />
                <Card.Body>
                  <Card.Title style={{height:"auto", fontFamily:"", paddingBottom:4}}>
                    <h4 className="mb-1" style={{fontWeight:600, fontSize:'1.25rem', margin:0}}>{item.title || item.reportName || item.prgName || item.issue || 'Magazine Issue'}</h4>
                    {formatMonthYear(item) && (
                      <small className="text-muted" style={{display:'block'}}>{formatMonthYear(item)}</small>
                    )}
                  </Card.Title>
                  <Card.Text className='max-lines' style={{color:'#444', fontSize:'1rem', lineHeight:1.5, marginTop:8}}>
                    {item.Description || item.description || item.desc || ''}
                  </Card.Text>
                </Card.Body>
                <Card.Footer>
                  <PdfViewing data={item} url={`${config.s3.imageUrl}website/kanal/${item.prgID}/${item.reportID}/${item.pdfUrl}`} />
                </Card.Footer>
              </Card>
            ))}
            {!loading && selectedItems.length === 0 && !error && (
              <div className='text-muted p-3'>No details available for this year.</div>
            )}
          </CardGroup>
        </Col>
      </Row>
    </div>
  )
}
